import React from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { PrivatesTable } from './components/PrivatesTable';
import { usePrivateLibraryStateURLSynchronizer } from './components/usePrivateLibraryStateURLSynchronizer';
import { cn } from '@/lib/utils';

const PrivateAssetLibrary = () => {
  const history = useHistory<{ shouldListenerIgnore?: boolean }>();
  usePrivateLibraryStateURLSynchronizer(history);

  const LIBRARY_CONTENT_CLASS = 'library-content';

  return (
    <div className={cn('pb-5', LIBRARY_CONTENT_CLASS)}>
      <PrivatesTable />
    </div>
  );
};

export default withRouter(PrivateAssetLibrary);
